<template>
  <div>
     <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Authority Appraisal Evaluation
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
             <v-row class="sub-row" justify="center" dense>
                <v-col cols="12" xs="12" sm="2" lg="2" md="12">
                    <p class="padding-bot"><b>Academic Year</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="academicyear" @change="show=false;getAuthorities()" :items="aylist" item-text="ay" item-value="id" label="Academic Year" outlined />
                </v-col>
                 <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                    <p class="padding-bot"><b>Select Authority</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="authority" :items="authorities" item-text="auth" @change="show=false" item-value="id" label="Authority" outlined />
                </v-col>

                 <!-- Select Department -->
                <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                    <p class="padding-bot"><b>Select Department</b></p>
                    <v-autocomplete color="#0F2027" dense rounded v-model="selectedDepartment" 
                        :items="department_list" item-text="name" item-value="id" 
                        @change="filterInstructors" label="Department" outlined />
                </v-col>
                <!-- Select Employee Payment Section -->
                <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                    <p class="padding-bot"><b>Employee Payment Section</b></p>
                    <v-autocomplete color="#0F2027" dense rounded v-model="selectedPaymentSection" 
                        :items="employee_payment_section_list" item-text="name" item-value="id" 
                        @change="filterInstructors" label="Payment Section" outlined />
                </v-col>

                 <!-- Filtered Instructor List -->
                <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                    <p class="padding-bot"><b>Instructor List</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="instructor" 
                        @change="show=false" :items="filteredInstructorList" item-text="name" 
                        item-value="id" label="Instructor" outlined />
                </v-col>

             <!-- </v-row>
            <v-row class="sub-row" justify="center" dense v-if="show_row"> -->
                <!-- <v-col cols="12" xs="12" sm="2" lg="2" md="12">
                    <p class="padding-bot"><b>Instructor List</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="instructor" @change="show=false" :items="instructor_list" item-text="name" item-value="id" label="Instructor" outlined />
                </v-col> -->
                <v-col cols="12" xs="12" sm="2" lg="2" md="12">
                    <p class="padding-bot"><b></b></p><br>
                    <!-- <v-btn class="toolbar" outlined dense rounded :loading="loader" @click="fetchSelfAppriasalData"> Fetch</v-btn> -->
                    <v-btn class="toolbar" outlined dense rounded :loading="loader" v-if="instructor" @click="getReport"> Fetch</v-btn>
                </v-col>
            </v-row>

             <apprisal-report v-if="show==true" :key="index"></apprisal-report>
        </v-card>
        
  </div> 
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import GetTeacherApprisalPerformanceMeasurementReport from './GetTeacherApprisalPerformanceMeasurementReport'
export default {
    components:{
    'apprisal-report':GetTeacherApprisalPerformanceMeasurementReport,
},
  data: () => ({
    department_list:[],
    employee_payment_section_list:[],
    selectedDepartment: null,
    selectedPaymentSection: null,
    show:false,
    loader: false,
    proceed_loader: false,
    search: "",
    snackbar_msg: "",
    snackbar: false,
    color: "",
    aylist:[],
    instructor_list:[],
    instructor:"",
    academicyear:"",
    basepath:"",
    selfAuthoritymarks:[],
    all_data_list:[],authorities:[],authority:"",show_row:false,
    show_table:false,
    headers: [
    { text: "Sr. No.", value: "srno", sortable: "true" },
    { text: "Faculty", value: "instructor", sortable: "true"},
    { text: "Self marks", value: "selfmarks", sortable: "true" },
    { text: "Authority marks", value: "recomondingmarks", sortable: "true" },
    { text: "Proceed", value: "proceed", sortable: "true" },
    ],
    index:0,
  }),
  methods: {
    getAuthorities(){
      this.authorities=[]
      const data = {
        ay: this.academicyear,
      };
      this.overlay = true;
      this.loader = true;
      axios
        .post("/Appraisal/getAuthoritiesByAY", data)
        .then((res) => {
          if (res.data.flag == "YES") {
           (this.authorities = res.data.authorities)
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          //this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
        });
    },
    filterInstructors() {
            this.filteredInstructorList = this.instructor_list.filter(inst => {
                const matchesDepartment = this.selectedDepartment ? inst.department_id === this.selectedDepartment : true;
                const matchesPaymentSection = this.selectedPaymentSection ? inst.employeepaymentsection_id === this.selectedPaymentSection : true;
                return matchesDepartment && matchesPaymentSection;
            });
        },
     getReport(){
        this.index++
        this.show = false
        this.loader=true
        localStorage.setItem("setay", this.academicyear);
        localStorage.setItem("setinst", this.instructor);
        localStorage.setItem("authority", this.authority);
        this.show = true
        this.loader=false
        },
        // getAuthData(){
        // this.loader=true
        // this.instructor_list=[]
        // this.instructor=null
        // const formData = {
        //     authority: this.authority,
        // };
        // axios
        // .post("/Appraisal/getAuthData",formData) 
        // .then((res) => {
        //     if (res.data.flag == "YES") {
        //         this.loader=false
                
        //         this.basepath = res.data.aws_path;
        //         this.instructor_list=res.data.instructor_list_recommending
        //         this.academicyear=res.data.cay
        //         this.show_row=true
        //     } else {
        //         this.loader=false
        //         //   window.console.log(res.data.msg);
        //         this.showSnackbar("#b71c1c", "Something went wrong!");
        //     }
        // })
        // .catch((error) => {
        //     window.console.log(error);
        // })
        // .finally(() => {});
        // },


        submit: function (e) {
            var form = document.getElementById("payment-form");
            var formData = new FormData(form);
           axios
        .post("/FillSelfAppriasal/Save_recommending_Marks",formData)
        .then((res) => {
            if (res.data.flag == "YES") {
                this.loader=false
                this.all_data_list=res.data.final_List
                this.showSnackbar("#4caf50", "Saved Successfully...!");
                this.getReport();
            }else if(res.data.flag == "No"){
                this.loader=false
                this.showSnackbar("#b71c1c", res.data.snackbar);
                this.all_data_list=res.data.final_List
            } 
            else {
                //   window.console.log(res.data.msg);
                this.showSnackbar("#b71c1c", "Something went wrong!");
            }
    })
    .catch((error) => {
        window.console.log(error);
    })
    .finally(() => {
    });
      },
    proceed(item){
    this.proceed_loader=true
    this.all_data_list=[]
    const formData = {
        ay: this.academicyear,
        inst_id: item.id        
    };
    axios
    .post("/FillSelfAppriasal/proceed",formData)
    .then((res) => {
        if (res.data.flag == "YES") {
             this.proceed_loader=false
             this.all_data_list=res.data.final_List
             this.show_table=true
        }else if(res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar);
            this.proceed_loader=false
            this.all_data_list=[]
        }else {
            this.loader=false
            this.show_table=false
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
        }
    })
    .catch((error) => {
        window.console.log(error);
    })
    .finally(() => {});
    },
    fetchSelfAppriasalData(){
    this.loader=true
    const formData = {
        ay: this.academicyear,
        instructor: this.instructor.id,
    };
    axios
    .post("/FillSelfAppriasal/fetchSelfAppriasalData",formData)
    .then((res) => {
        if (res.data.flag == "YES") {
             this.loader=false
             this.selfAuthoritymarks=res.data.selfAuthoritymarks
        } else {
            this.loader=false
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
        }
    })
    .catch((error) => {
        window.console.log(error);
    })
    .finally(() => {});
    },

    onLoad() {
    axios
    .post("/Appraisal/getData")
    .then((res) => {
        if (res.data.flag == "YES") {
            this.aylist=res.data.aylist
            this.authorities=res.data.authorities
            this.instructor_list=res.data.inst_list
            this.department_list=res.data.department_list
            this.employee_payment_section_list=res.data.employee_payment_section_list
            //this.show_row=true
        } else {
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
        }
    })
    .catch((error) => {
        window.console.log(error);
    })
    .finally(() => {});
    },
    showSnackbar(clr, msg) {
    this.snackbar = true;
    this.color = clr;
    this.snackbar_msg = msg;
},
  },
   mounted() {
    this.onLoad();
    },
    watch: {
        instructor_list: {
            handler() {
                this.filterInstructors();
            },
            deep: true,
            immediate: true
        }
    }
};
</script>
<style scoped>
.tc-title {
        background-image: linear-gradient(-90deg, #fff, blue);
        color: #fff;
        border-radius: 3px;
    }

    .table-head {
    background: #0f2027; /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    color: white  !important;
    }
    .textcolor{
        color: darkblue;
        font-weight: bold;
    }
      td,
    th {
        border: 1px solid #ccc;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }
    td {
        font-weight: bold;
    }
    td{
        margin: 1rem !important;
        padding: 1rem !important;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
sub-row {
        border: 2px solid #424093;
        margin: 1rem;
        border-radius: 5px;
    }

    i {
        font-size: 20px !important;
    }

    .v-card__title {
        border: 1px solid #80808040;
        font-weight: bold;
        background-color: #424093;
        color: white;
        text-align: center;
        /* margin-top: 1.5rem; */
    }
    .card-border {
        border: 2px solid darkblue;
        border-radius: 10px;
        /* padding: 5px; */
        /* margin: 1rem !important; */
        width: auto;
    }

    .tx-bold {
        font-weight: bold;
        font-size: 14px;
        color: black;
    }

    i {
        font-size: 26px;
        cursor: pointer;
    }

    theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        background-color: #424093 !important;
        color: white !important;
        margin-top: 2.35rem;
        border-radius: 20px;
    }

    /*.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):hover {
    background-color: orange !important;
    color: black !important;
} */

    @media only screen and (max-width: 600px) {
    }

    .imgs {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        width: 150px;
        cursor: zoom-in;
    }

    .imgs-preview {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        width: auto;
    }

    v-simple-table {
        border-collapse: collapse;
        border-spacing: 0;
        width: auto;
        border: 1px solid #ddd;
    }

    th {
        color: white;
        font-weight: bold;
        text-align: center !important;
    }

    td,
    th {
        padding: 6px;
        border: 1px solid #ccc;
        text-align: center;
    }
    @media all and (max-width: 900px) {
        .padding-bot {
            padding: 8px;
        }
    }

    @media all and (min-width: 1000px) {
        .padding-metting {
            padding-right: 22px;
        }
    }
    @media (min-width: 320px) and (max-width: 350px) {
        .padding-bot {
            font-size: 11.6px;
        }
    }
    @media (min-width: 1000px) and (max-width: 1050px) {
        .padding-bot {
            font-size: 9.6px;
        }
    }
     .slide {
        color: red;
        font-weight: bold;
        margin-left: 10px;
    }


</style>
